import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import OpcoesPaginacao from '../comum/OpcoesPaginacao'
import {alterarRegistrosPorPagina, determinarPaginaAtual} from '../../actions/interessado-promocao/usuariosPromocaoActions'

export class PaginacaoInteressado extends Component {
  render () {
    return <OpcoesPaginacao
      registrosPorPagina={this.props.registrosPorPagina}
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      determinarPaginaAtual={this.props.determinarPaginaAtual}
      alterarRegistrosPorPagina={this.props.alterarRegistrosPorPagina}/>
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    alterarRegistrosPorPagina,
    determinarPaginaAtual
  }, dispatch)
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.interessadoPromocao.paginaAtual,
    total: state.interessadoPromocao.total,
    interessados: state.interessadoPromocao.interessados,
    registrosPorPagina: state.interessadoPromocao.registrosPorPagina
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaginacaoInteressado)
